<template>
  <section class='page-video-list'>
    <van-pull-refresh
      v-model="refreshing"
      @refresh="onRefresh"
    >
      <van-list
        v-model="listLoading"
        :finished="listFinished"
        @load="listOnLoad"
      >
        <ul
          class="card-item"
          v-for="(items, index) in listArr"
          :key="index"
        >
          <li
            @click="handleGoDetail(item)"
            class="card"
            v-for="item in items"
            :key="item.snowId"
            v-lazy:background-image="item.coverUrl"
          >
            <div
              class="live-sign"
              v-if="item.liveState === 1"
            >
              <span class="font10">
                直播中
              </span>
            </div>
            <ul class="bottom">
              <li>
                <div class="user-info">
                  <img
                    :src="item.avatar"
                    alt=""
                  >
                  <span class="clamp1 nick-name">
                    {{namefilter(item.nickName)}}
                  </span>
                </div>
                <p class="video-name font10 clamp1">
                  {{item.memo}}
                </p>
              </li>
              <li class="like-star">
                <div>
                  <img
                    src="@/assets/icon/list-like.png"
                    alt=""
                  >
                  <div class="font8">{{item.pointupCount}}</div>
                </div>

              </li>
            </ul>
          </li>
          <li
            class="card"
            v-if="items.length == 1"
          ></li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </section>
</template>

<script>
/* eslint-disable import/no-cycle */
import { apiSearchVideos } from '@/api/video-list';
import { nickNamefilter } from '@/assets/utils/utils';

export default {
  name: 'videoList',
  data() {
    return {
      cursorMark: '*',
      pageNumber: 1,
      listArr: [],
      listLoading: false,
      listFinished: false,
      rows: 20,
      refreshing: false,
    };
  },
  activated() {
    this.$NProgress.done();
  },
  methods: {
    namefilter(name) {
      return nickNamefilter(name);
    },
    async listOnLoad(isRefresh) {
      const { data } = await apiSearchVideos({ cursorMark: this.cursorMark, rows: this.rows });
      const {
        videos, total, cursorMark,
      } = data;
      this.cursorMark = cursorMark;

      if (Math.ceil(total / this.rows) === this.pageNumber) {
        this.listFinished = true;
      }
      this.pageNumber += 1;
      const videosList = [];
      for (let i = 0; i < videos.length; i += 2) {
        videosList.push(videos.slice(i, i + 2));
      }
      if (isRefresh) {
        this.listArr = videosList;
      } else {
        this.listArr.push(...videosList);
      }
      this.listLoading = false;
      this.$NProgress.done();
      if (this.refreshing) {
        setTimeout(() => {
          this.refreshing = false;
        }, 1000);
      }
    },
    handleGoDetail(item) {
      const {
        liveState, userId, snowId, liveVideoId,
      } = item;
      // 直播
      if (liveState === 1) {
        this.$router.push({
          path: 'live',
          query: {
            userId,
            snowId: liveVideoId,
          },
        });
      } else {
        this.$router.push({
          path: '/',
          query: {
            userId,
            snowId,
          },
        });
      }
    },
    onRefresh() {
      this.listFinished = false;
      this.listLoading = true;
      this.pageNumber = 1;
      this.cursorMark = '*';
      this.listOnLoad(true);
    },
  },
  created() {
    this.$store.commit('keepAlive', 'videoList');
  },
};
</script>

<style lang='less' scoped>
.page-video-list {
  padding: 10px 0 10px;
  font-size: 12px;
  color: #ffffff;
  .card-item{
    display: flex;
    padding:0 20px;
    >li:first-child{
      margin-right: 8px;
    }
    >li:last-child{
      margin-left: 8px;
    }
    .card{
      flex: 1;
      background-position: center top;
      background-size: cover;
      margin-bottom: 10px;
      padding: 5px;
      border-radius: 4px;
      height: 230px;
      position: relative;
      .live-sign{
        display: inline-block;
        background: rgba(0,0,0,.25);
        border-radius: 10px;
        padding-left: 22px;
        padding-right: 6px;
        position: relative;
        line-height: 20px;
        height: 20px;
        &::before{
          content: "";
          background-repeat: no-repeat;
          background-image: url('~@/assets/icon/list-live.gif');
          background-color: #DD515E;
          background-position: center;
          background-size: 12px;
          position: absolute;
          width: 20px;
          height: 20px;
          left: 0;
          top: 0;
          border-radius: 50%;
        }
      }
      .bottom{
        position: absolute;
        bottom: 6px;
        display: flex;
        right: 6px;
        left: 6px;
        justify-content: space-between;
        .user-info{
          margin-bottom: 5px;
          display: flex;
          align-items: center;
          img{
            width: 30px;
            height: 30px;
            border: 1px solid #ffffff;
            border-radius: 50%;
            margin-right: 4px;
          }
          .nick-name{
            width: 80px;
            display: inline-block;
          }
        }
        .video-name{
          width: 120px;
        }
        .like-star{
          text-align: right;
          align-self: flex-end;
          >div{
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          img{
            width: 20px;
            height: 20px;
            margin-bottom: 5px;
          }
          .font8{
            transform-origin: top;
          }
        }
      }
    }
  }

}
</style>
